import { useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    useGetBrandsQuery,
    useGetBrandCountQuery,
} from "../../../../store/api/barand_master";
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import PopBox from "../../../../Components/Popup/Popup";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ExportCSV from '../../../../Core/Export/ExportCSV'
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
const MainContent = () => {
    const navigate = useNavigate();
    const { screenHeight, screenScaling,pageSize } = useScreenHeight();


    const [totalData, setTotalData] = useState("");
    const [filters, setFilters] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const [isPopBoxOpen, setIsPopBoxOpen] = useState(false);
    const [totalRecords, setTotalRecords] = useState([]);
    const [showExportPopup, setShowExportPopup] = useState(false);

    const [showFilters, setShowFilters] = useState(false)
    const [showColumnConfig, setShowColumnConfig] = useState(false)
    //States Used for deleted the record
    const [deleteDoc] = useDeleteDocMutation();
    const [delPopupVisible, setDelPopupVisible] = useState(false);
    const [delSelectedId, setDelSelectedId] = useState(null);
    const [delmessage, setDelmessage] = useState();
    const [alreadySubmitData, setAlreadySubmitData] = useState(false);
    const [delDone, setDelDone] = useState(false);

    const filtersConfig = [
        { name: 'siNo', label: 'S. No.', width: '9%', type: 'number' },
        { name: "name", label: "Name", width: "27%", type: 'text' },
        // { name: "description", label: "Description", width: "25%", type: 'text' },
        { name: "creation", label: "Date", type: 'date', width: "30%" },
    ];

    const buildFilterArray = (filtersObj) => {
        return Object.entries(filtersObj)
            .filter(([key, value]) => key !== "siNo" && String(value).trim() !== "")
            .map(([key, value]) => ["Brand", key, "like", `%${value}%`]);
    };

    const siNoFilter = filters.siNo?.trim();
    const siNoNumber = parseInt(siNoFilter, 10);
    const isSiNoActive = !isNaN(siNoNumber);
    const targetPage = isSiNoActive
        ? Math.ceil(siNoNumber / pageSize)
        : currentPage;

    const { data: brandData, isLoading, refetch:refetchBrandData } = useGetBrandsQuery({
        start: (targetPage - 1) * pageSize,
        limit: pageSize,
        filters: buildFilterArray(filters),
    });

    const { data: count, refetch:refetchBrandCount } = useGetBrandCountQuery();

    useEffect(() => {
        if (count) {
            setTotalData(count.message);
        }
    }, [count]);

    useEffect(() => {
        if (brandData) {
            const rawData = brandData.data || [];
            const numberedData = rawData.map((item, idx) => ({
                ...item,
                siNo: idx + 1 + pageSize * (targetPage - 1),
            }));
            const finalData = isSiNoActive
                ? numberedData.filter((item) => item.siNo === siNoNumber)
                : numberedData;

            setTotalRecords(finalData);
            if (isSiNoActive && currentPage !== targetPage) {
                setCurrentPage(targetPage);
            }
        }
    }, [brandData, isSiNoActive, siNoNumber, targetPage, currentPage,screenHeight, screenScaling, pageSize]);

    useEffect(() => {
        if(pageSize > 0)
            refetchBrandData();
    }, [filters, currentPage, refetchBrandData, pageSize,screenHeight, screenScaling]);


    const handleView = (id) => {
        navigate(`/master/brand/view-brand/`, {
            state: { PurchaseId: id },
        });
    };

    const handleEdit = (id) => {
        navigate(`/master/brand/edit-brand/`, {
            state: { PurchaseId: id },
        });
    };

    const handleDelete = (id) => {
			setDelSelectedId(id);
			setDelPopupVisible(true);
			setAlreadySubmitData(false);
			setDelmessage("Are you sure you want to Delete this Brand?");
		};

	const delHandleCancel = () => {
		setDelPopupVisible(false);
		setDelSelectedId(null);
	};

	const delHandleConfirm = async () => {
		try {
			await deleteDoc({
					doctype: "Brand",
					name: delSelectedId,
				}).unwrap();
				setDelmessage(`Brand ${delSelectedId} deleted successfully!`);
				setDelDone(true);
				setTimeout(() => {
					setDelPopupVisible(false);
					setDelSelectedId(null);
					setDelDone(false);
					refetchBrandCount();
					refetchBrandData();
				}, 1000);
			} catch (err) {
				console.error("Deletion Failed:", err);

				let errorMessage = "Failed to delete the Brand!";

				//If the server is sending the error message , we will extract it.
				if (err?.data?._server_messages) {
					try {
						const messageArr = JSON.parse(err.data._server_messages);
						if (messageArr && messageArr.length > 0) {
							//parse inner json object
							const messageObj = JSON.parse(messageArr[0]);
							if (messageObj?.message) {
								//extract the exact message we want
								const fullMessage = messageObj.message;
								errorMessage = fullMessage.trim();
								//remove html in the message
								errorMessage = errorMessage.replace(/<[^>]+>/g, "");
							}
						}
					} catch (parseError) {
						console.error("Error parsing server messages:", parseError);
					}
				}
				setDelPopupVisible(true);
				setDelmessage(errorMessage);
				setAlreadySubmitData(true);
			} finally {
				// setTimeout(() => {
				//     setDelPopupVisible(false);
				//     setDelSelectedId(null);
				// }, 2000);
			}
	};

    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: "6.8%",
            cellRenderer: (row) => row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Brand",
            name: "Brand",
            accessor: "name",
            sortable: true,
            width: "23%",
            visible: true
        },
        // {
        //     header: "Description",
        //     accessor: "description",
        //     sortable: true,
        //     width: "23%",
        //     visible:true,
        //     style: {
        //         wordBreak: "break-word",
        //         whiteSpace: "normal",
        //         maxWidth: "200px",
        //     },
        // },
        {
            header: "Date",
            name: "Date",
            accessor: "creation",
            sortable: true,
            width: "27%",
            visible: true,
            cellRenderer: (row) => row.creation?.split(" ")[0],
        },
        {
            header: "Action",
            name: "Action",
            accessor:'action',
            width: "0%",
            visible: true,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            ),
        },
    ]);

    // Handle column configuration changes
    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        setCurrentPage(1);
    };

    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns)
    }
    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);

    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: "2px", height: "28px" },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),

        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/master/brand/create-brand",
            iconName: "FiPlus",
            style: { gap: "2px", height: "28px" },
            children: "Add Brand",
        },
    ];
    const accessors = columnsConfig
        .filter(column => column.accessor !== "siNo" && column.accessor !=="action")
        .map(column => column.accessor);


    return (
        <div className="container-fluid d-flex flex-column" style={{ flexGrow: "1" }}>
            <Tabs />
            <ListLayout
                breadcrumbItems={[
                    { label: "Brand" },
                    { label: "Brand List", style: { color: "#270B79" } },
                ]}
                actionButtons={actionButtons}
            >
                {
                    showFilters && <ListFilters
                        filtersConfig={filtersConfig}
                        onFilterChange={handleFilterChange}
                        currentFilters={filters}
                        setShowFilters={setShowFilters}
                    />
                }

                {
                    showColumnConfig && <ConfigureColumnsNew
                        show={showColumnConfig}
                        onClose={() => setShowColumnConfig(false)}
                        onSave={handleSaveColumns}
                        docType="Brand"
                        defaultSelected={defaultSelectedColumns}
                        fieldsData={columnsConfig.map(col => ({
                            fieldname: col.accessor,
                            label: col.name
                        }))}
                        disabledFields={["siNo","action", "creation", "name"]}
                    />
                }
                <Table
                    columns={visibleColumns}
                    data={totalRecords}
                    loading={isLoading}
                />
                <Pagination
                    setCurrentPage={setCurrentPage}
                    pageSize={pageSize}
                    totalRecords={totalData}
                    currentPage={currentPage}
                    className="mt-2 pb-3"
                />
                {delPopupVisible && (
                    <DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
                )}
                {showExportPopup && (
                    <ExportCSV
                        doctype="Brand"
                        fieldsData={accessors}
                        onClose={() => setShowExportPopup(false)}
                    />
                )}
                <PopBox
                    isOpen={isPopBoxOpen}
                    onClose={() => setIsPopBoxOpen(false)}
                    title="Select Company"
                >
                    <div className="selectbox">
                        <p>Settings content goes here</p>
                    </div>
                </PopBox>
            </ListLayout>
        </div>
    );
};

export default MainContent;
